import { scoreRecordToSet } from '../helpers/scoreRecordToSet'
import { RiskMethodologyCalculator } from '../RiskMethodologyCalculator'

export const RiskMethodologyCalculatorMatrix: RiskMethodologyCalculator = {
  getRiskScore: ({ riskMatrixCells, probabilityId, impactId }) => {
    const score = riskMatrixCells?.find((cell) => cell.probabilityId === probabilityId && cell.impactId === impactId)?.score
    return score !== undefined ? { label: String(score), score } : { label: null }
  },
  getRiskScoreValue: ({ score }) => score,
  getChipLabel: ({ label, matrixLevels, score, hideName }) => {
    if (hideName) return label

    const matrixLevel = matrixLevels.find((item) => item.score === score)
    if (!matrixLevel) return label

    return `${label} – ${matrixLevel.name}`
  },
  getPossibleScores: ({ riskMatrixCells, impacts, probabilities }) => ({
    riskMatrixScores: scoreRecordToSet(riskMatrixCells),
    impactScores: scoreRecordToSet(impacts),
    probabilityScores: scoreRecordToSet(probabilities),
  }),
  getMethodology: () => 'MATRIX',
}
